module.exports = __webpack_public_path__ + "img/zp1.8531d7fe.png";